import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "history-section"
};
const _hoisted_2 = { class: "history-title" };
const _hoisted_3 = {
    key: 0,
    class: "badge"
};
const _hoisted_4 = { class: "expand-btn" };
const _hoisted_5 = {
    key: 0,
    class: "history-body"
};
const _hoisted_6 = {
    key: 0,
    class: "history-loading"
};
const _hoisted_7 = {
    key: 1,
    class: "history-empty"
};
const _hoisted_8 = { key: 2 };
const _hoisted_9 = { class: "history-table" };
const _hoisted_10 = { class: "date-cell" };
const _hoisted_11 = { class: "id-cell" };
const _hoisted_12 = { class: "id-cell" };
const _hoisted_13 = { class: "error-cell" };
const _hoisted_14 = {
    key: 0,
    class: "pagination"
};
const _hoisted_15 = ["disabled"];
const _hoisted_16 = { class: "page-info" };
const _hoisted_17 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.configId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
                class: "history-header",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.isExpanded = !_ctx.isExpanded))
            }, [
                _createElementVNode("h3", _hoisted_2, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", null, "📊 Historique des envois", -1)),
                    (_ctx.total > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.total), 1))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("button", _hoisted_4, _toDisplayString(_ctx.isExpanded ? '▲' : '▼'), 1)
            ]),
            (_ctx.isExpanded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_ctx.isLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[4] || (_cache[4] = [
                                _createElementVNode("div", { class: "mini-spinner" }, null, -1),
                                _createElementVNode("span", null, "Chargement...", -1)
                            ]))]))
                        : (!_ctx.logs.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[5] || (_cache[5] = [
                                    _createElementVNode("span", null, "Aucun envoi enregistré pour cette règle.", -1)
                                ]))]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("table", _hoisted_9, [
                                    _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", null, "Date"),
                                            _createElementVNode("th", null, "Canal"),
                                            _createElementVNode("th", null, "Statut"),
                                            _createElementVNode("th", null, "Utilisateur"),
                                            _createElementVNode("th", null, "Commande"),
                                            _createElementVNode("th", null, "Erreur")
                                        ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (log) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: log.id
                                            }, [
                                                _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.formatDate(log.sent_at)), 1),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(['channel-badge', log.channel.toLowerCase()])
                                                    }, _toDisplayString(log.channel === 'PUSH' ? '🔔' : '📧') + " " + _toDisplayString(log.channel), 3)
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(['status-badge', log.status.toLowerCase()])
                                                    }, _toDisplayString(_ctx.getStatusIcon(log.status)) + " " + _toDisplayString(log.status), 3)
                                                ]),
                                                _createElementVNode("td", _hoisted_11, _toDisplayString(log.user_id ? log.user_id.slice(0, 8) + '...' : '-'), 1),
                                                _createElementVNode("td", _hoisted_12, _toDisplayString(log.order_id ? log.order_id.slice(0, 8) + '...' : '-'), 1),
                                                _createElementVNode("td", _hoisted_13, _toDisplayString(log.error_message || '-'), 1)
                                            ]));
                                        }), 128))
                                    ])
                                ]),
                                (_ctx.total > _ctx.pageSize)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _createElementVNode("button", {
                                            class: "page-btn",
                                            disabled: _ctx.page === 0,
                                            onClick: _cache[1] || (_cache[1] =
                                                //@ts-ignore
                                                (...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                                        }, "← Précédent", 8, _hoisted_15),
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.page + 1) + " / " + _toDisplayString(_ctx.totalPages), 1),
                                        _createElementVNode("button", {
                                            class: "page-btn",
                                            disabled: _ctx.page >= _ctx.totalPages - 1,
                                            onClick: _cache[2] || (_cache[2] =
                                                //@ts-ignore
                                                (...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                                        }, "Suivant →", 8, _hoisted_17)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                ]))
                : _createCommentVNode("", true)
        ]))
        : _createCommentVNode("", true);
}
